/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var loginMessageHtml = '<h4 style="padding-top:10px;" data-product-login-message>To see pricing, <a href="/account/login">log in</a> or <a href="/pages/create-an-account">create an account</a>.</h4>';
  var availableAtText = 'Available at:';

  function findTextNodeContaining(root, text) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node = walker.nextNode();

    while (node) {
      if (node.nodeValue.indexOf(text) !== -1) {
        return node;
      }

      node = walker.nextNode();
    }

    return null;
  }

  function getInsertTarget(textNode, container) {
    var blockSelector = 'p, div, h1, h2, h3, h4, h5, h6, ul, ol, table, blockquote';
    var element = textNode.parentElement;

    while (element && element !== container) {
      if (element.matches(blockSelector)) {
        return element;
      }

      element = element.parentElement;
    }

    return textNode;
  }

  function insertProductLoginMessages() {
    var description = document.querySelector('.product-tabs > .tab-content.current.rte');
    
      var messageWrapper = document.createElement('div');
      messageWrapper.innerHTML = loginMessageHtml;
      var message = messageWrapper.firstElementChild;

      var availableAtNode = findTextNodeContaining(description, availableAtText);

      if (availableAtNode) {
        var target = getInsertTarget(availableAtNode, description);

        target.parentNode.insertBefore(message, target);

        return;
      }

      var paragraphs = description.querySelectorAll('p');
      var lastParagraph = paragraphs[paragraphs.length - 1];

      if (lastParagraph) {
        lastParagraph.insertAdjacentElement('afterend', message);
      } else {
        description.appendChild(message);
      }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertProductLoginMessages);
  } else {
    insertProductLoginMessages();
  }

  document.addEventListener('shopify:section:load', insertProductLoginMessages);

})();
